import { CatalogPageState as CatalogPageStateBase } from '../../app/catalog/CatalogPageState';
import { IApiClient } from '../../app/data/client';
import { CatalogPageTranslation } from '../../app/localization/SiteTranslation';
import { IEventAggregator } from '../../app/shared/EventAggregator';
import { INavigationService } from '../../app/shared/NavigationService';
import { FamilyItemAvailabilityModalState } from './FamilyItemAvailabilityModal/FamilyItemAvailabilityModalState';

export class CatalogPageState extends CatalogPageStateBase {
  public familyItemAvailabilityModal: FamilyItemAvailabilityModalState;

  public constructor(
    translation: CatalogPageTranslation,
    navigation: INavigationService,
    client: IApiClient,
    eventAggregator: IEventAggregator,
  ) {
    super(translation, navigation, client, eventAggregator, 10);
    this.familyItemAvailabilityModal = new FamilyItemAvailabilityModalState();
  }
}
